import { useRouter } from "@tanstack/react-router"
import { Card, CardDescription, CardHeader, CardTitle } from "design-system/molecules/Card"
import { useCreateBackofficeScheduledReportsMutation } from "modules/backoffice/hooks/scheduledReports/useCreateBackofficeScheduledReportsMutation"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { BackofficeScheduledReportsSearchSchema } from "routes/_base/_auth/backoffice/scheduledReports/list/route"
import { UpsertBackofficeScheduledReportSchema } from "schema"
import { toast } from "sonner"
import { z } from "zod"
import { BackofficeScheduledReportForm } from "./BackofficeScheduledReportForm"

export const BackofficeScheduledReportCreator = () => {
  const { t } = useTranslation()
  const { navigate } = useRouter()
  const { mutateAsync, isPending } = useCreateBackofficeScheduledReportsMutation()
  const [error, setError] = useState<string | null>(null)

  const onSubmit = async (data: z.input<typeof UpsertBackofficeScheduledReportSchema>) => {
    setError(null)
    const response = await mutateAsync(data)

    if ("error" in response.data) {
      setError(response.data.error as string)
    } else {
      toast.success(t("backoffice.scheduledReports.createSuccess"))
      navigate({
        to: "/backoffice/scheduledReports/list",
        search: BackofficeScheduledReportsSearchSchema.parse({}),
      })
    }
  }

  return (
    <>
      <Card className="bg-yellow-100 border-yellow-200 p-2">
        <CardDescription className="text-yellow-900">
          {t("backoffice.scheduledReports.create.emailReminder", {
            email: "permut@permut-486414.iam.gserviceaccount.com",
          })}
        </CardDescription>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>{t("backoffice.scheduledReports.create.title")}</CardTitle>
          <CardDescription>{t("backoffice.scheduledReports.create.description")}</CardDescription>
        </CardHeader>
        <BackofficeScheduledReportForm
          onSubmit={onSubmit}
          submitCopy={t("backoffice.scheduledReports.create.save")}
          isPending={isPending}
          error={error}
        />
      </Card>
    </>
  )
}
